/* Copyright 2022 SIB Visions GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */

import React, { createContext, FC } from "react";

// Creates a context to know if the app is embedded
export const EmbeddedContext = createContext<{ [key:string]:any }|undefined>({});

// Interface for EmbedContext
interface IEmbedContext {
    embedOptions?:{ [key:string]:any },
    children?: React.ReactNode
}

/** This component provides an embeddedcontext to know if the app is embedded */
const EmbedProvider: FC<IEmbedContext> = (props) => {
    return (
        <EmbeddedContext.Provider value={props.embedOptions}>
            {props.children}
        </EmbeddedContext.Provider>
    )
}
export default EmbedProvider